export default __webpack_public_path__ + "static/media/1566.3c6c3b17.png";